import { GET_RESPONSE_TYPES } from "@core/store/action-constants";
import { UPDATE_RESPONSE_TYPES_LIST } from "@core/store/mutation-constants";
import { RootState } from "@core/store/root-state";
import { ResponseTypesListState } from "@core/store/types/admin/crm/lists/ResponseTypesListState";
import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import i18n from "@core/plugins/i18n";

const initialState = (): ResponseTypesListState => {
  return {
    data: {}
  };
};

const state: () => ResponseTypesListState = initialState;

const getters: GetterTree<ResponseTypesListState, RootState> = {};

const mutations: MutationTree<ResponseTypesListState> = {
  [UPDATE_RESPONSE_TYPES_LIST] (state, responseTypes: ResponseTypesListState["data"]) {
    state.data = responseTypes;
  }
};

const actions: ActionTree<ResponseTypesListState, RootState> = {
  [GET_RESPONSE_TYPES] ({ commit }) {
    const items = [
      {
        label: "xml",
        value: "XML"
      },
      {
        label: "json",
        value: "JSON"
      },
      {
        label: i18n.t("admin.crm.modal.labels.recoveryDetail.emptyResponseTypes"),
        value: null
      }
    ];
    commit(UPDATE_RESPONSE_TYPES_LIST, {
      items,
      count: items.length
    });
  }
};

export const responseFormatTypesList: Module<ResponseTypesListState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
